import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-auto-logout',
    templateUrl: './auto-logout.component.html',
    standalone: false
})
export class AutoLogoutComponent implements OnInit {

  inactivityTimeoutInMinutes = 240; // 4 hours
  userActivityRedirect: any


  setTimeout() {
    this.userActivityRedirect = setTimeout(() => this.onLoginExpired.emit(), (this.inactivityTimeoutInMinutes * 60 * 1000));
  }

  clearTimeout() {
    clearTimeout(this.userActivityRedirect);
    this.setTimeout();
  }

  @HostListener('document:mousemove') mouseActive() {
    this.clearTimeout();
  }

  @HostListener('document:keydown') keyboardActive() {
    this.clearTimeout();
  }

  @Output() onLoginExpired = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    this.setTimeout();
  }

}
